import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaterialThemeModule } from '@hunter/material-theme';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialThemeModule,
    MatTabsModule,
    MatRippleModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatMenuModule,
    MatSidenavModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatExpansionModule,
    MatInputModule,
    MatBadgeModule,
    DragDropModule
  ],
  exports: [
    MaterialThemeModule,
    MatTabsModule,
    MatRippleModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatMenuModule,
    MatSidenavModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatExpansionModule,
    MatInputModule,
    MatBadgeModule,
    DragDropModule
  ]
})
export class MaterialModule { }
